const fbConfig = {
    apiKey: "AIzaSyCnwvZhnMO3NH7ZYwJ1GhoqblLf4NqHzik",
    authDomain: "nite-scout.firebaseapp.com",
    databaseURL: "https://nite-scout-default-rtdb.firebaseio.com",
    projectId: "nite-scout",
    storageBucket: "nite-scout.appspot.com",
    messagingSenderId: "933034745105",
    appId: "1:933034745105:web:af2a2da02034ca84fb40b0"
};
export default fbConfig;